<template>
  <div class="h5-center">
    <HeaderH5 :platInfo="platInfo"></HeaderH5>
    <div class="h5-content">
      <router-view></router-view>
    </div>
    <FooterH5 :platInfo="platInfo"></FooterH5>
  </div>
</template>

<script setup>
import { ref, computed, defineProps} from 'vue'
import { useRouter, useRoute } from 'vue-router'
import FooterH5 from "../components/footers/footerH5.vue"
import HeaderH5 from "../components/headers/headerH5.vue"

    const router = useRouter()
    const route = useRoute()
    const menuOpen = ref(false)
    const props = defineProps({
        platInfo: {
            type: Object,
            default: {}
        }
    })
    const currentPath = computed(() => route.path)
    const navList = [
      { name: '首页', path: '/h5/index' },
      { name: '1+3体系', path: '/h5/framework' },
      { name: '标准服务', path: '/h5/standardService' },
      { name: '检测服务', path: '/h5/testService' },
      { name: '品质评价服务员', path: '/h5/QualityEvaluation' },
      { name: '关于我们', path: '/h5/aboutUs' },
    ]
    const tabList = [
      { name: '首页', path: '/h5/index', match: 'index', icon: '🏠' },
      { name: '标准', path: '/h5/standardService', match: 'standard', icon: '📋' },
      { name: '检测', path: '/h5/testService', match: 'test', icon: '🔬' },
      { name: '品质', path: '/h5/QualityEvaluation', match: 'Quality', icon: '⭐' },
      { name: '关于', path: '/h5/aboutUs', match: 'aboutUs', icon: '👤' },
    ]
    const goPage = (path) => {
      router.push(path)
      menuOpen.value = false
    }
    const goHome = () => {
      router.push('/h5/index')
    }
</script>

<style lang="less" scoped>
.h5-center {
  width: 100%;
  min-height: 100vh;
  background: #f8f8f8;

  .h5-header {
    position: fixed;
    top: 0; left: 0; right: 0;
    height: 50px;
    background: #0754BD;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    z-index: 1000;

    .h5-logo {
      font-size: 18px;
      color: #fff;
      font-weight: 600;
      cursor: pointer;
    }

    .h5-hamburger {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 24px;
      height: 18px;
      cursor: pointer;
      span {
        display: block;
        height: 2px;
        background: #fff;
        border-radius: 2px;
      }
    }
  }

  .h5-nav-mask {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.5);
    z-index: 1001;
  }

  .h5-nav-drawer {
    position: fixed;
    top: 0;
    right: -280px;
    width: 280px;
    height: 100vh;
    background: #fff;
    z-index: 1002;
    transition: right 0.3s ease;
    overflow-y: auto;

    &.open { right: 0; }

    .h5-nav-close {
      padding: 15px;
      font-size: 15px;
      color: #333;
      cursor: pointer;
      background: #f5f5f5;
      border-bottom: 1px solid #e0e0e0;
    }

    .h5-nav-item {
      padding: 14px 20px;
      border-bottom: 1px solid #f0f0f0;
      font-size: 15px;
      color: #333;
      cursor: pointer;
      &:active { background: #f5f5f5; }
    }
  }

  .h5-content {
    margin-top: 60px;
    // padding-bottom: 60px;
    min-height: calc(100vh - 60px);
  }

  .h5-tab-bar {
    position: fixed;
    bottom: 0; left: 0; right: 0;
    height: 60px;
    background: #fff;
    display: flex;
    border-top: 1px solid #e8e8e8;
    z-index: 1000;

    .h5-tab-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #999;

      .tab-icon { font-size: 20px; }
      .tab-name { font-size: 11px; margin-top: 2px; }

      &.active { color: #0754BD; }
    }
  }
}
</style>
